/**
 * Team Insights redesigned charts — the release gate, in ONE place.
 *
 * Area 'teamInsightsCharts' in src/utils/followups/uiVersion.js (own key `teamio_team_insights_charts_ui`, no fallback). At STAGE
 * 'preview' only Super Admins get the new charts; every office keeps today's pie charts:
 *   gate OFF  the classic chart.js pies, byte for byte;
 *   gate ON   the redesigned cards (src/pages/TeamInsights/redesign/), fed the same chartData as the pies.
 *
 * Every consumer calls teamInsightsChartsUiOn() — never shouldUseNewFollowupsUi directly — so the userKey rule
 * ("every gate call passes the employee ID") is kept in one spot, as src/utils/formsSettings/gate.js does for Forms Settings.
 */
import { shouldUseNewFollowupsUi, browserStorage } from '@/utils/followups/uiVersion.js';

/**
 * @param {{ isSuperAdmin?: boolean, userKey?: (string|number|null), storage?: object }} [who]
 *   isSuperAdmin  the viewer's role is 'Super Admin' (exactly)
 *   userKey       the employee ID (the office's own "classic Teamio" choice is stored per person)
 * @returns {boolean} true ⇒ draw the redesigned charts
 */
export function teamInsightsChartsUiOn({ isSuperAdmin, userKey, storage } = {}) {
  return shouldUseNewFollowupsUi('teamInsightsCharts', {
    isSuperAdmin: isSuperAdmin === true,
    storage: storage === undefined ? browserStorage() : storage,
    userKey,
  });
}
